import script from "./XInputNumber.vue?vue&type=script&lang=ts&setup=true"
export * from "./XInputNumber.vue?vue&type=script&lang=ts&setup=true"

import "./XInputNumber.vue?vue&type=style&index=0&id=54d549c6&lang=css&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d549c6"]])

export default __exports__